import {
  ActivityData,
  PostActivityResponse,
} from '@dc-shared-web/hooks/api/activity/types'
import invariant from 'tiny-invariant'

export const fetchActivity = async (
  url: string,
  token: string,
  payload: ActivityData
): Promise<PostActivityResponse> => {
  invariant(url, 'Activity service URL is not set')
  invariant(token, 'Activity service token is not set')

  const response = await fetch(`${url}/activity`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'x-dc-app': 'dcrunch-web',
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    throw new Error(`Activity service error: ${response.status}`)
  }

  return {
    activity_guid: payload.activity_guid || '',
    success: true,
  }
}
